import Vue from "vue";
import Router from "vue-router";
import Permissions from '@/services/Permissions';
import Auth from '@/services/Auth';
import Store from '@/store';
import LoginPage from "../pages/LoginPage.vue";
import Home from "../pages/Home.vue";
import Preschool from "../pages/Preschool.vue";
import Essential from "../pages/Essential.vue";
import Preek from "../pages/Preek.vue";
import Mission from "../pages/Mission.vue";
import MissionPreschool from "../pages/MissionPreschool.vue";
import MissionPreek from "../pages/MissionPreek.vue";
import MissionEssential from "../pages/MissionEssential.vue";
import Libro from "../pages/Libro.vue";
import LibroPreschool from "../pages/LibroPreschool.vue";
import LibroPreek from "../pages/LibroPreek.vue";
import LibroEssential from "../pages/LibroEssential.vue";
import LibroLecturaPreschool from "../pages/LibroLecturaPreschool.vue";
import Actividad from "../pages/activities.vue";
import Actividades from "../pages/actividades.vue";
import resources from "../pages/resources.vue";
import resourcesEssential from "../pages/resourcesEssential.vue";
import Tests from "../pages/Tests.vue";
import Activities from "../pages/activities/index.vue";
import Activity1 from "../pages/activities/Activity1.vue";
import Activity2 from "../pages/activities/Activity2.vue";
import Activity3 from "../pages/activities/Activity3.vue";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({
  showSpinner: false,
  trickle: false,
});

Vue.use(Router);

const ANY_ROLE = '*';

const router = new Router({
  mode: "hash",
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash };
    return { top: 0 };
  },
  base: process.env.BASE_URL,
  routes: [

    // RUTAS DE PRIMARIA
    {
      path: '/',
      name: 'Dashboard',
      components: {
        default: Home
      },
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/mission/:missionId',
      name: 'Mission',
      components: {
        default: Mission
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/mission/:missionId/libro',
      name: 'Libro',
      components: {
        default: Libro
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/mission/:missionId/recursos',
      name: 'resources',
      components: {
        default: resources
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },

    // ----------------------------------------------

    // RUTAS DE PREESCOLAR
    {
      path: '/preschool',
      name: 'Home',
      components: {
        default: Preschool
      },
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/preschool/mission/:missionId',
      name: 'MissionPreschool',
      components: {
        default: MissionPreschool
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },

    {
      path: '/preschool/mission/:missionId/libro',
      name: 'LibroPreschool',
      components: {
        default: LibroPreschool
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/preschool/mission/:missionId/libro-lectura',
      name: 'LibroPreschool',
      components: {
        default: LibroLecturaPreschool
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },

    // ------------------------------------------------

    // RUTAS ESSENTIAL
    {
      path: '/essential',
      name: 'Home',
      components: {
        default: Essential
      },
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/essential/mission/:missionId',
      name: 'MissionEssential',
      components: {
        default: MissionEssential
      },
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/essential/mission/:missionId/libro',
      name: 'LibroEssential',
      components: {
        default: LibroEssential
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/essential/mission/:missionId/recursos',
      name: 'resourcesEssential',
      components: {
        default: resourcesEssential
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },

    // ---------------------------------------

    // RUTAS DE PREEK
    {
      path: '/preek',
      name: 'Home',
      components: {
        default: Preek
      },
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/preek/mission/:missionId',
      name: 'MissionPreek',
      components: {
        default: MissionPreek
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/preek/mission/:missionId/libro',
      name: 'LibroPreek',
      components: {
        default: LibroPreek
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },

    // --------------------------------------------

    {
      path: '/mission/:missionId/actividad',
      name: 'Actividad',
      components: {
        default: Actividad
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/mission/:missionId/actividad/:actividadId',
      name: 'Actividades',
      components: {
        default: Actividades
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/mission/:missionId/recursos',
      name: 'resources',
      components: {
        default: resources
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      }
    },
    {
      path: '/tests',
      name: 'Tests',
      components: {
        default: Tests
      },
      props: true,
      meta: {
        allowedRoles: ['ASC'],
      }
    },
    {
      path: '/mission/:missionId/activities',
      name: 'Activities',
      components: {
        default: Activities
      },
      props: true,
      meta: {
        allowedRoles: [ANY_ROLE],
      },
      children: [
        {
          path: 'activity1',
          name: 'Activity1',
          components: {
            default: Activity1
          },
          props: true,
        },
        {
          path: 'activity2',
          name: 'Activity2',
          components: {
            default: Activity2
          },
          props: true,
        },
        {
          path: 'activity3',
          name: 'Activity3',
          components: {
            default: Activity3
          },
          props: true,
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      components: {
        default: LoginPage
      },
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../pages/NotFound.vue'),
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});

async function checkPermissions(routeToCheck) {
  for (let i = 0; i < routeToCheck.matched.length; i += 1) {
    const route = routeToCheck.matched[i];

    if (route.meta && route.meta.allowedRoles) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await Auth.authenticate();
        if (!result) return false;
      } catch (error) {
        return false;
      }

      const routeRoles = route.meta.allowedRoles;

      if (routeRoles.includes(ANY_ROLE)) return true;
      if (!Permissions.compareRoles(routeRoles, Auth.getDecodedToken().scope)) return false;
      return true;
    }
  }
  return true;
}

router.beforeEach(async function (to, from, next) {
  NProgress.start();
  try {
    let canEnter = true;
    if (
      to.name === 'Mission'
      || to.name === 'Libro'
      || to.name === 'Actividad'
      || to.name === 'resources'
    ) {
      let e = parseInt(localStorage.getItem('userGrade'));
      if(e) {
        let ee = parseInt(to.params.missionId)
        if(e !== ee) {
          next({
            path: '/',
          });
        }
      }
    }
    if (
      to.name !== 'NotFound'
      && to.name !== 'Login'
      && from.name !== 'Login'
      && from.name !== 'Format'
    ) {
      Store.dispatch('session/setIsAuthenticating', true);
      canEnter = await checkPermissions(to);
      NProgress.set(0.3);
    }
    if (canEnter) {
      console.log('Allowed');
      next();
    } else {
      console.log('Denied');
      next({
        path: '/login',
      });
    }
  } catch (error) {
    console.error(error);
  } finally {
    Store.dispatch('session/setIsAuthenticating', false);
  }
});

router.afterEach(() => {
  NProgress.set(0.5);
});

export default router;
